module.exports = __webpack_public_path__ + "static/media/aws.cb68f979.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/aws.png
 ** module id = 211
 ** module chunks = 0
 **/